import useStartNewHpDeviceAmendment, {
    IUseStartNewHpDeviceAmendmentOutput,
} from "./useStartNewHpDeviceAmendment"
import { LCTOnlyDatasets } from "../../../../../constants/enums"

/**
 * Thin wrapper around useStartNewHpDeviceAmendment — the only difference is
 * the dataset passed to the API (EB vs HP). All form data, types, and mappers
 * are shared.
 */
const useStartNewEbDeviceAmendment = (
    deviceRef: string,
    attachmentUUID: string
): IUseStartNewHpDeviceAmendmentOutput =>
    useStartNewHpDeviceAmendment(deviceRef, attachmentUUID, LCTOnlyDatasets.EB)

export default useStartNewEbDeviceAmendment
